import { ON_SERVER } from 'helpers';
import { useUser } from 'contexts/user-context';
import { HmacSHA256 } from 'crypto-js';

const intercomID = process.env.INTERCOM_ID;
const intercomSecret = process.env.INTERCOM_API_KEY;

const Intercom: React.FC<{ authenticated: boolean }> = ({ authenticated }) => {
  const { user } = useUser();

  if (ON_SERVER) return null;
  if (!authenticated) {
    (window as any).intercomSettings = {
      app_id: intercomID,
      hide_default_launcher: false,
    };
    if (typeof (window as any).Intercom === 'function') {
      (window as any).Intercom('reattach_activator');
      (window as any).Intercom('update', (window as any).intercomSettings);
    }
    return null;
  }

  const userHash = HmacSHA256(user?.id, intercomSecret)?.toString();

  (window as any).intercomSettings = {
    app_id: intercomID,
    hide_default_launcher: true,
    user_id: user?.id,
    user_hash: userHash,
    email: user?.email,
    phone: user?.phone,
  };

  if (typeof (window as any).Intercom === 'function') {
    (window as any).Intercom('reattach_activator');
    (window as any).Intercom('update', (window as any).intercomSettings);
  } else {
    const intercom = (): void => {
      // @ts-ignore
      intercom.call(arguments); // eslint-disable-line fp/no-arguments, no-undef
    };

    intercom.queue = [];

    intercom.call = (args) => {
      intercom.queue.push(args);
    };

    (window as any).Intercom = intercom;
  }

  return null;
};

export default Intercom;
